module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/first_dance-bb3da65004441040b46e468dc257c686.webp";